<template>
  <div>
    <ministry-breadcrumbs
      :mainTitle="$route.meta.title"
      :breadcrumbs="$route.meta.breadCrumb"
    />
    <b-card>
      <b-card no-body class="border">
        <b-tabs lazy>
          <template #tabs-end>
            <div class="ml-auto d-flex justify-content-end mt-1 mx-2">
              <!-- <b-button
                v-can="{ slug: $route.meta.slug, action: 'C' }"
                variant="success"
                @click="
                  $router.push({
                    name: 'add-role',
                    params: { slug: activeSlug },
                  })
                "
              >
                <feather-icon icon="PlusIcon" />
                إضافة دور
              </b-button> -->
            </div>
          </template>
          <b-tab :title="models[0].title" @click="activeSlug = models[0].slug">
            <b-tabs content-class="">
              <b-tab title="أدوار" active>
                <div  class="ml-auto d-flex justify-content-end mx-2 mb-1">
                  <b-button
                    v-can="{ slug: $route.meta.slug, action: 'C' }"
                    variant="success"
                    @click="
                      $router.push({
                        name: 'add-role',
                        params: { slug: activeSlug },
                      })
                    "
                  >
                    <feather-icon icon="PlusIcon" />
                    إضافة دور
                  </b-button>
                </div>
                <data-table
                  ref="estatesTable"
                  :fields="fields"
                  ep="v2/ministry/roles"
                  :pagination="false"
                  :initialParams="{
                    type: 'MIN',
                  }"
                  class="mx-1"
                >
                  <template #cell(actions)="row">
                    <div class="d-flex justify-content-end align-items-center">
                      <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </template>

                        <b-dropdown-item
                          v-can="{ slug: $route.meta.slug, action: 'U' }"
                          @click="
                            $router.push({
                              name: 'update-role',
                              params: { id: row.item.id, slug: activeSlug },
                            })
                          "
                        >
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50">تعديل</span>
                        </b-dropdown-item>

                        <b-dropdown-item
                          @click="onDelete(row.item)"
                          v-can="{ slug: $route.meta.slug, action: 'D' }"
                        >
                          <feather-icon icon="Trash2Icon" />
                          <span class="align-middle ml-50">حذف</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </template>
                </data-table>
              </b-tab>
              <b-tab title="أدوار طلبات المعاملات" >
                <b-row class="mb-2 mx-1">
                  <b-col cols="3">

                    <form-input
                      class="mb-0"
                      v-model="searchKey.full_name"
                      placeholder="بحث بحسب اسم الموظف"
                    />
                  </b-col>
                  <b-col cols="9" class="d-flex justify-content-end">

                    <b-button
                      v-can="{ slug: $route.meta.slug, action: 'C' }"
                      variant="success"
                      @click="onClickAddTransactionRoles"
                    >
                      <feather-icon icon="PlusIcon" />
                      إضافة دور
                    </b-button>
                  </b-col>
                  
                </b-row>
                
                <data-table
                  ref="transactionRolesTable"
                  :fields="fieldsRolesTable"
                  ep="v2/ministry/transaction-request-roles"
                  :pagination="true"
                  class="mx-1"
                >
                <template #cell(transaction_role_count)="row">
                  <b-badge variant="light-secondary">
                    {{row.item.transaction_role_count}}
                  </b-badge>
                </template>
                
                <template #cell(actions)="row">
                    <div class="d-flex align-items-center justify-content-end">
                    <b-button
                        variant="flat-info"
                        @click="id = row.item.id ; row.toggleDetails()"
                        title="عرض المزيد من المعلومات"
                        size="sm"
                        class="btn-icon rounded-circle"
                        v-b-tooltip.hover.v-info.top
                    >
                        <feather-icon icon="InfoIcon" size="1.8x" color="#82868b" />
                    </b-button>
                    </div>
                </template>
                <template #row-details="row">
                    <b-card  v-show="id === row.item.id">
                    <b-row class="mb-2">
                        <b-col md="12" class="mb-1 d-flex">
                            <strong> الأدوار المُسندة له :</strong>
                        </b-col>
                        <b-col cols="12">

                            <div class="text-info">
                                <div v-if="loadingTransictionRole" >
                                    <b-skeleton width="1500px"  height="300px"  ></b-skeleton>
                                </div>
                                <div v-else>
                                    <b-table striped hover  :fields="fieldsUserRolesTable" :items="transictionRole">
                                      <template #cell(actions)="row">
                                        <div class="d-flex justify-content-end align-items-center">
                                          <b-dropdown
                                            variant="link"
                                            no-caret
                                            :right="$store.state.appConfig.isRTL"
                                          >
                                            <template #button-content>
                                              <feather-icon
                                                icon="MoreVerticalIcon"
                                                size="16"
                                                class="align-middle text-body"
                                              />
                                            </template>


                                            <b-dropdown-item
                                              v-can="{ slug: $route.meta.slug, action: 'S' }"
                                              @click="onClickEditTransactionRoles(row.item)"
                                            >
                                              <feather-icon icon="EditIcon" />
                                              <span class="align-middle ml-50">تعديل</span>
                                            </b-dropdown-item>

                                            <b-dropdown-item
                                              @click="onDeleteTransictionRole(row.item)"
                                              v-can="{ slug: $route.meta.slug, action: 'S' }"
                                            >
                                              <feather-icon icon="Trash2Icon" />
                                              <span class="align-middle ml-50">حذف</span>
                                            </b-dropdown-item>
                                          </b-dropdown>
                                        </div>
                                      </template>
                                    </b-table>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
    
                    <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="row.toggleDetails"
                    >
                        عرض اقل
                    </b-button>
                    </b-card>
                </template>
                </data-table>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab :title="models[1].title" @click="activeSlug = models[1].slug">
            
            <div  class="ml-auto d-flex justify-content-end mx-2 mb-1">
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'C' }"
                variant="success"
                @click="
                  $router.push({
                    name: 'add-role',
                    params: { slug: activeSlug },
                  })
                "
              >
                <feather-icon icon="PlusIcon" />
                إضافة دور
              </b-button>
            </div>
            <data-table
              ref="estatesTable"
              :fields="fields"
              ep="v2/ministry/roles"
              :pagination="false"
              :initialParams="{ type: 'NGO' }"
              class="mx-1"
            >
              <template #cell(actions)="row">
                <div class="d-flex justify-content-end align-items-center">
                  <b-button
                    variant="primary"
                    class="p-0 px-1"
                    style="height: 25px; font-size: 12px"
                    @click="
                      $router.push({
                        name: 'update-role',
                        params: { id: row.item.id, slug: activeSlug },
                      })
                    "
                  >
                    الصلاحيات
                  </b-button>
                  <b-dropdown
                    variant="link"
                    no-caret
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>

                    <b-dropdown-item
                      v-can="{ slug: $route.meta.slug, action: 'S' }"
                      @click="
                        $router.push({
                          name: 'update-role',
                          params: { id: row.item.id, slug: activeSlug },
                        })
                      "
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">تعديل</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click="onDelete(row.item)"
                      v-can="{ slug: $route.meta.slug, action: 'S' }"
                    >
                      <feather-icon icon="Trash2Icon" />
                      <span class="align-middle ml-50">حذف</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </data-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
    

    <role-modal
      :loading="working"
      @confirm="onAddTransactionRoles"
      v-model="RoleModal"
    />
    <role-modal
      :loading="working"
      @confirm="onEditTransactionRoles"
      v-model="editModal"
      :intializeForm="editForm"
      :loadingTransictionRole="loadingTransictionRole"
      title="تعديل دور طلب معاملة"
      :id ="ministry_user_id"
      ifEdit
      ref="editActivityModal"
      
    />
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BTab,
  BTabs,
  BBadge ,
  VBTooltip ,
  BCol ,
  BRow ,
  BSkeleton ,
  BTable
} from "bootstrap-vue";
import DataTable from "@/components/data-table/index.vue";
import { mapActions, mapGetters } from "vuex";
import saveBtn from "@/components/loader-btn";
import FormModal from "@/components/FormModal.vue";
import FormInput from "@/components/form-input";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import RoleModal from "@/modules/ministry/components/RoleModal.vue";
import debounce from "lodash.debounce";

export default {
  components: {
    BCard,
    BButton,
    DataTable,
    BFormCheckbox,
    saveBtn,
    BDropdown,
    BDropdownItem,
    FormModal,
    MinistryBreadcrumbs,
    BTab,
    BTabs,
    RoleModal , 
    BBadge ,
    BCol ,
    BRow ,
    BSkeleton ,
    BTable,
    FormInput
  },
  data: () => {
    return {
      loading : false ,
      activeTableIndex: 0,
      RoleModal : false ,
      editModal : false ,
      ministry_user_id :null,
      editForm : {},
      searchKey: {},
      id:null ,
      models: [
        {
          title: "أدوار الوزارة",
          slug: "MIN",
        },
        {
          title: "أدوار المنظمة",
          slug: "NGO",
        },
      ],

      activeSlug: "MIN",

      fields: [
        {
          key: "name",
          label: "اسم الدور",
        },
        { key: "actions", label: " " },
      ],
      fieldsRolesTable:[
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "full_name",
          label: "اسم الموظف",
        },
        {
          key: "transaction_role_count",
          label: "عدد الأدوار المُسندة له",
        },
        { key: "actions", label: " " },

      ],
      fieldsUserRolesTable:[
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "transactionRole.name",
          label: "الدور",
        },
        {
          key: "transactionType.name",
          label: "المعاملة",
        },
        {
          key: "governorate.name_ar",
          label: "المحافظة",
        },
        { key: "actions", label: " " },

      ],
      updateModel: false,
      show: false,
      create: false,
      update: true,
      delete_s: true,
      roleFormSchema: {
        name: {
          component: "FormInput",
          key: "name",
          attrs: {
            label: "اسم الدور",
            rules: "required",
          },
        },
        name_rols: {
          component: "FormSelect",
          key: "role_ids",
          attrs: {
            id: "role_ids",
            ep: "v2/selects/roles",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name,
            label: "الصلاحيات",
            rules: "required",
            multiple: true,
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("Ministry/Settings/Roles", ["deleteRole" , "createTransictionRole" , "deleteTransictionRole" , "getTransictionRole" , "updateTransictionRole"]),

    onDelete(item) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الدور", {
          title: "تأكيد حذف الدور",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteRole({ id: item.id, slug: this.activeSlug }).then(() => {
              this.$refs.estatesTable.refreshTable();
            });
        });
    },
    onDeleteTransictionRole(item) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الدور", {
          title: "تأكيد حذف الدور",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteTransictionRole({ id: item.id}).then(() => {
              this.$refs.transactionRolesTable.refreshTable();
              this.id = null
            });
        });
    },
    onUpdateClicked(form) {
      var toUpdate = {
        name: form.name,
      };
      this.$refs.estateModalUser.init(toUpdate);
      this.updateModel = true;
    },
    onAddClicked() {
      this.$refs.estateModalUser.init({});
      this.updateModel = true;
    },
    onModalConfirmed() {},
    onClickAddTransactionRoles(){
      this.RoleModal = true
    },
    onClickEditTransactionRoles(item){

      console.log(item)
      this.ministry_user_id = this.id
      this.editForm.idEdit = item.id
      this.editForm.data =[{}]
      this.editForm.data[0].transaction_role_id = item.transactionRole.id
      this.editForm.data[0].transaction_type_id = item.transactionType.id
      if(item.governorate){

        this.editForm.data[0].governorate_id = item.transactionRole.id
      }
      this.$refs.editActivityModal.init(this.editForm);
      this.editModal = true

    },
    onAddTransactionRoles(form){
      const keys = Object.keys(form.data);
      var req = new FormData();
      req.append(`ministry_user_id`, form.ministry_user_id);
      form.data.forEach((obj, index) => {
        for (var key in obj) {
          req.append(`data[${index}][${key}]`, obj[key]);
        }
      });
      this.createTransictionRole({ data:req }).then(() => {
        this.$refs.transactionRolesTable.refreshTable();
        this.RoleModal = false
      });
    },
    onEditTransactionRoles(form){
      console.log('form' , form)
      const keys = Object.keys(form.data);
      var req = new FormData();
      form.data.forEach((obj, index) => {
        for (var key in obj) {
          if(`${key}` !== 'idEdit'){
            req.append(`${key}`, obj[key]);
          }
          
        }
      });
      req.append(`ministry_user_id`, form.ministry_user_id);
      this.updateTransictionRole({ data:req , id:form.idEdit }).then(() => {
        this.$refs.transactionRolesTable.refreshTable();
        this.editModal = false
        this.id = null
      });
    },

  },
  
  watch:{
    async id(val) {
      if(val){
        await this.getTransictionRole({ id: this.id})
      }
        
    },
    searchKey: {
      deep: true,
      handler: debounce(function (value) {
        this.$refs.transactionRolesTable.setQueryParams({
        ...this.searchKey ,
        });
        this.$refs.transactionRolesTable.refreshTable();
      }, 300),
    },
   },
  directives: {
    "b-tooltip": VBTooltip,
  },
  computed: {
    ...mapGetters("Ministry/Settings/Roles", [
      "parmassins",
      "loadingParmassins",
      "working" , 
      "loadingTransictionRole" , 
      "transictionRole" ,
      
    ]),
  },
};
</script>
<style>
.form-group {
  margin-bottom: 0rem;
}
</style>
